module.exports = __webpack_public_path__ + "img/ye.d13e1629.svg";